/**
 * Browser Bundle Entry Point
 * Auto-init bundle for non-developer usage with script tag
 *
 * Usage:
 * <script
 *   src="https://cdn.lionrapid.com/lionrapid.auto.min.js"
 *   data-api-key="pk_live_xxx"
 * ></script>
 */

// Core exports for advanced usage
export { LionRapidBuilder } from '../builder.js';
export { LionRapidCore } from '../lionRapid.js';
export { MemoryRepository, NetworkRepository } from '../repositories/index.js';

// Browser-specific exports
export { AutoTranslator } from './auto-translator.js';
export type { AutoTranslatorConfig } from './auto-translator.js';

export { LanguageSwitcher } from './language-switcher.js';
export type { Language, SwitcherStyle } from './language-switcher.js';

export { BlockExtractor } from './block-extractor.js';
export type { ExtractedBlock } from './block-extractor.js';

export { AttributeExtractor } from './attribute-extractor.js';
export type { ExtractedAttribute } from './attribute-extractor.js';

export { parseBlockElement } from './markup-parser.js';

export { ExcludeFilter } from './exclude-filter.js';
export type { ExcludePatterns } from './exclude-filter.js';

export { DOMObserver } from './dom-observer.js';
export type { DOMObserverCallbacks } from './dom-observer.js';


export { md5, generateAutoKey } from './md5.js';

// Storage exports
export { LocalStorageRepository } from './storage/localstorage-repository.js';
export type { LocalStorageRepositoryConfig } from './storage/localstorage-repository.js';

export { CacheStorageRepository } from './storage/cache-storage-repository.js';
export type { CacheStorageRepositoryConfig } from './storage/cache-storage-repository.js';

// Auto-init (runs on script load)
export { autoInit, parseConfig } from './auto-init.js';
export type { AutoInitConfig, LionRapidInstance } from './auto-init.js';
